import {takeEvery} from 'redux-saga/effects'
import {GET_CHANGE_LOGS} from 'setup/redux/Actions/ChangeLog/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_CHANGE_LOGS, fetchData)
}

export default dataSaga
